import { Component, OnInit } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import {
    OUTPUT,
    INPUT,
    BINARY,
    ONE_HOUR_IN_MILISECONDS,
    PRIORITY_8,
} from "src/app/config/constants";
import { Point } from "src/app/models/dashboard";
import {
    OverrideDataPoint,
    OverrideDataPointResponse,
} from "src/app/models/data-point";
import { BackendService } from "src/app/services/backend/backend.service";

@Component({
    selector: "cc-manage-override-dialog",
    templateUrl: "./manage-override-dialog.component.html",
    styleUrl: "./manage-override-dialog.component.scss",
    standalone: false,
})
export class ManageOverrideDialogComponent implements OnInit {
    isFailed = null;
    manageOverrideForm: FormGroup;
    dataPoint: Point;
    BINARY = BINARY;
    INPUT = INPUT;
    OUTPUT = OUTPUT;
    requestInProgress = false;
    readonly PERMANENTLY = "Permanently";
    constructor(
        private ref: DynamicDialogRef,
        private config: DynamicDialogConfig,
        private fb: FormBuilder,
        private backendService: BackendService,
    ) {}

    ngOnInit(): void {
        this.dataPoint = this.config.data.kpiPoint;
        this.manageOverrideForm = this.fb.group({
            name: new FormControl(
                this.dataPoint?.comment ||
                    this.dataPoint?.sourceDescription ||
                    this.dataPoint?.classLabel,
                [Validators.required]
            ),
            value: new FormControl(null, [Validators.required]),
            durationType: new FormControl(null, [Validators.required]),
            rollbackTimer: new FormControl(null, [
                Validators.required,
                Validators.min(1),
                Validators.max(168),
            ]),
            property: new FormControl(""),
            priority: new FormControl(""),
            resultCode: new FormControl(""),
        });


        if (this.dataPoint.signalType === BINARY) {
            this.newValue.setValue(false);
        }

        if (this.dataPoint.htmlSymbol !== "°C") {
            this.newValue.addValidators(Validators.min(0));
        } else {
            this.newValue.removeValidators(Validators.min(0));
        }

        this.durationType.valueChanges.subscribe((value) => {
            if (value === this.PERMANENTLY) {
                this.rollbackTimer.removeValidators(Validators.required);
                this.rollbackTimer.setValue(null);
            } else {
                this.rollbackTimer.addValidators(Validators.required);
            }
        });
    }

    get rollbackTimer() {
        return this.manageOverrideForm.get("rollbackTimer");
    }

    get newValue() {
        return this.manageOverrideForm.get("value");
    }

    get durationType() {
        return this.manageOverrideForm.get("durationType");
    }

    closeDialog() {
        if (this.manageOverrideForm.get("property").value) {
            this.ref.close({ updateDPSuccess: true });
        } else {
            this.ref.close();
        }
    }

    updateDataPointValue() {
        this.requestInProgress = true;
        let newValue = this.manageOverrideForm.get("value").value;
        if (this.dataPoint.signalType === BINARY) {
            newValue = this.manageOverrideForm.get("value").value ? 1 : 0;
        }
        const newDataPointValue: OverrideDataPoint = {
            dataPointId: this.dataPoint.pointUUID,
            value: newValue,
            rollbackTimer:
                this.durationType.value === this.PERMANENTLY
                    ? null
                    : this.rollbackTimer.value * ONE_HOUR_IN_MILISECONDS,
        };

        this.backendService
            .writeCommand(newDataPointValue, PRIORITY_8)
            .subscribe(
                (response: OverrideDataPointResponse[]) => {
                    this.requestInProgress = false;
                    if (response[0].success) {
                        this.isFailed = false;
                        this.manageOverrideForm
                            .get("property")
                            .setValue(response[0].result.context.property);
                        this.manageOverrideForm
                            .get("priority")
                            .setValue(response[0].result.context.priority);
                    } else {
                        this.manageOverrideForm.get("property").setValue(null);
                        this.manageOverrideForm.get("priority").setValue(null);
                        this.manageOverrideForm
                            .get("resultCode")
                            .setValue(response[0].result.code);
                        this.isFailed = true;
                    }
                },
                (err) => {
                    this.requestInProgress = false;
                }
            );
    }
}
